/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types,jsx-a11y/no-noninteractive-element-interactions,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import { removeUserModel } from 'mt-react-common/modules/messenger/reducers/static/forms/createGroupRoom/createGroupRoomForm';

const createRoomFormRN = 'messengerModule.forms.createRoomForm';

// eslint-disable-next-line react/prefer-stateless-function
class AddUserItem extends Component {
  getMarkers = () => {
    const markers = [];
    if (this.props.item.isMyReferrer) markers.push(t('Мой реферер'));
    if (this.props.item.isMyReferral) markers.push(t('Мой реферал'));
    if (this.props.item.concatRoles) markers.push(t('Администрация'));
    return markers.join(' | ');
  };

  render() {
    return (
      <tr>
        <td>
          <div className="media">
            <div className="media-left">
              <img
                alt=""
                className="media-object avatar avatar-xs"
                src={this.props.item.profile.avatarPath}
              />
            </div>
            <div className="media-body media-middle">
              <div className="text-caption">
                <span>{this.props.item.username}</span>{' '}
                <span className="text-muted">{this.getMarkers()}</span>
              </div>
            </div>
          </div>
        </td>
        <td className="text-right">
          <button
            className="btn btn-default btn-sm"
            type="submit"
            onClick={e => {
              this.props.removeUserModel(this.props.index);
            }}
          >
            <i className="fa fa-minus-circle" /> {t('Удалить')}
          </button>
        </td>
      </tr>
    );
  }
}

AddUserItem.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    username: PropTypes.string,
    concatRoles: PropTypes.string,
    isMyReferrer: PropTypes.bool,
    isMyReferral: PropTypes.bool,
    profile: PropTypes.shape({
      avatarPath: PropTypes.string
    })
  }).isRequired,

  // CONNECT
  removeUserModel: PropTypes.func.isRequired
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  removeUserModel: value => dispatch(removeUserModel(createRoomFormRN, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUserItem);



// WEBPACK FOOTER //
// ./src/components/Messenger/content/MessengerGroupRoomFormPopUp/common/RemoveUserItem.js